import StyleSheetRW from "core/StyleSheetRW";
import React, { useEffect, useState } from "react";
import DateField from "src/components/DateField";
import { textFieldFilteration } from "src/utils/TextFieldUtils";
import closeIcon from "res/img/cross.png";
import { AddProjectFormStyles } from "./styles/AddProjectFormStyles"
import { db } from "@react-native-firebase/database";
import { get, ref } from "firebase/database";
import { getLocalStorageItem } from "core/helpers";
import Loader from "src/components/Loader";

interface AddProjectForm {
    onClose: () => void;
    onSave: (projectData: any) => void;
    onUpdate: (projectData: any, projectId: string) => void;
    editProjectId: string;
}

const AddProjectForm: React.FC<AddProjectForm> = ({ onClose, onSave, editProjectId, onUpdate }) => {
    const [projectData, setProjectData] = useState({
        projectName: '',
        startDate: '',
        clientName: ''
    });

    const [errors, setErrors] = useState({
        projectName: '',
        startDate: '',
        clientName: ''
    });
    const loggedinUser = getLocalStorageItem("loggedinUser");
    const [showLoader, setShowLoader] = useState(false);


    useEffect(() => {
        if (editProjectId && loggedinUser) {
            setShowLoader(true);
            const dbRef = ref(db, `projectRecord/${loggedinUser.uid}/${editProjectId}`);
            get(dbRef).then((snapshot) => {
                const data = snapshot.val();
                if (data) {
                    setProjectData({
                        projectName: data.projectName,
                        startDate: data.startDate,
                        clientName: data.clientName
                    });
                    setShowLoader(false);
                }
            }).catch(() => {
                console.log("Error retrieving data");
                setShowLoader(false);
            })
        }
    }, [])

    const handleSetFormValues = (name: string, value: any,) => {
            setProjectData({ ...projectData, [name]: value});
        setErrors({ ...errors, [name]: '' });
    };

    const validate = () => {
        let isValid = true;
        let newErrors = { projectName: '', startDate: '', clientName: '' };

        if (!projectData.projectName) {
            newErrors.projectName = 'Project Name is required';
            isValid = false;
        }

        if (!projectData.startDate) {
            console.log(projectData.startDate);
            newErrors.startDate = 'Start Date is required';
            isValid = false;
        }

        if (!projectData.clientName) {
            newErrors.clientName = 'Client Name is required';
            isValid = false;
        }

        setErrors(newErrors);
        return isValid;
    };

    const handleSubmit = (e: any) => {
        e.preventDefault();
        if (validate()) {
            if (editProjectId) {
                onUpdate(projectData, editProjectId);
            } else {
                onSave(projectData);
            }
            onClose();
        }
    };

    return (
        <div style={AddProjectFormStyles.overlay}>
            <div style={AddProjectFormStyles.dialog}>
                <h2 style={AddProjectFormStyles.heading}>
                    {editProjectId ? 'Edit' : 'Add New Project'}</h2>
                <button style={AddProjectFormStyles.closeButton} onClick={onClose}>
                    <img src={closeIcon} alt="Close" style={{ width: 13, height: 13, }} />
                </button>
                <form onSubmit={handleSubmit}>
                    <div style={AddProjectFormStyles.inputContainer}>
                        <label style={AddProjectFormStyles.label}>Project Name*</label>
                        <input
                            style={AddProjectFormStyles.input}
                            type="text"
                            name="projectName"
                            value={projectData.projectName}
                            onChange={(e) => handleSetFormValues("projectName", e.target.value)}
                            placeholder="Project name"
                        />
                        {errors.projectName && <span style={AddProjectFormStyles.error}>{errors.projectName}</span>}
                    </div>
                    <div style={AddProjectFormStyles.inputContainer}>
                        <label style={AddProjectFormStyles.label}>Start Date*</label>
                        <DateField
                            value={projectData.startDate}
                            placeholder="yyyy-MM-dd"
                            onChangeText={(text) => { handleSetFormValues('startDate', text) }}
                            label=''
                        />
                        {errors.startDate && <span style={{ ...AddProjectFormStyles.error, marginTop: 0 }}>{errors.startDate}</span>}
                    </div>
                    <div style={AddProjectFormStyles.inputContainer}>
                        <label style={AddProjectFormStyles.label}>Client Name*</label>
                        <input
                            style={AddProjectFormStyles.input}
                            type="text"
                            name="clientName"
                            value={projectData.clientName}
                            onChange={(e) => handleSetFormValues("clientName", e.target.value)}
                            placeholder="Client Name"
                        />
                        {errors.clientName && <span style={AddProjectFormStyles.error}>{errors.clientName}</span>}
                    </div>
                    <button style={AddProjectFormStyles.button} type="submit">
                        {editProjectId ? 'Update' : 'Add'}
                    </button>
                </form>
            </div>
            {showLoader && <Loader />}
        </div>
    );
};

export default AddProjectForm;